import { MessageCircle } from "lucide-react";
import { useWhatsAppBubble } from "@/hooks/useWhatsAppBubble";
import { motion } from "framer-motion";
import { useRef } from "react";
import { useTracking } from "@/hooks/useInteractionTracking";

export const WhatsAppBubble = () => {
  const { data: settings, isLoading } = useWhatsAppBubble();
  const constraintsRef = useRef<HTMLDivElement>(null);
  const isDragging = useRef(false);
  const { trackClick } = useTracking();

  if (isLoading || !settings?.enabled || !settings?.link) {
    return null;
  }

  const handleClick = () => {
    // Only open WhatsApp if we weren't dragging
    if (!isDragging.current) {
      trackClick("whatsapp_support_bubble", { link: settings.link });
      window.open(settings.link, "_blank");
    }
  };

  return (
    <>
      {/* Invisible container for drag constraints */}
      <div
        ref={constraintsRef}
        className="fixed inset-0 pointer-events-none z-40"
        style={{ bottom: "80px" }} // Leave space for mobile nav
      />
      <motion.button
        drag
        dragConstraints={constraintsRef}
        dragElastic={0.1}
        onDragStart={() => {
          isDragging.current = true;
        }}
        onDragEnd={() => {
          // Reset after a short delay to allow click to be blocked
          setTimeout(() => {
            isDragging.current = false;
          }, 100);
        }}
        whileDrag={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleClick}
        className="fixed top-20 right-4 z-50 flex h-10 w-10 md:h-14 md:w-14 cursor-grab items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-colors hover:bg-[#20BD5A] focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2 active:cursor-grabbing md:top-auto md:bottom-6 md:right-6"
        aria-label="Contact us on WhatsApp"
      >
        <MessageCircle className="h-5 w-5 md:h-7 md:w-7" />
      </motion.button>
    </>
  );
};
